import React, { useState, useEffect, useCallback } from 'react';
import { APP_OTP_SIZE, CANJE_OTP_TITLE } from '../shared/Constantes';
import OtpInput from 'react-otp-input';
import styled from 'styled-components';
import { StyledSpan } from '../shared/StyledSpan';
import { TemplateCanje } from './TemplateCanje';
import { Box } from '@bpba/ui-components';
import { theme } from '@bpba/ui-components';
import { GetOtpPayload } from '../shared/GetPayload';
import { otpMutation } from '../../rest/mutations/otp.post';
import { Mutations } from '../../rest/Mutations';
import { useMutation } from '@apollo/client';
import { Spinner } from '../shared/Spinner';
import { ResponseOtp } from '../../rest/models/ResponseOtp';
import { GenericErrorHandler, TMRandRetryErrorHandler } from '../shared/GenericErrorHandler';
import { BsEnvelopeOpen } from 'react-icons/bs';

type FormOTPProps = {
  otpCallback: (token?: string) => void;
  handleError: (message?: string) => void;
  token: string | undefined;
};

export const FormOTP = (props: FormOTPProps) => {
  const [otp, setOTP] = useState<string>('');
  const [validate, { loading }] = useMutation<Mutations>(otpMutation);
  const [msg, setMsg] = useState<string | null>(null);

  const handleError = useCallback(
    (error: any) => {
      return TMRandRetryErrorHandler(error) === null
        ? GenericErrorHandler(props.handleError, error)
        : setMsg(TMRandRetryErrorHandler(error));
    },
    [props.handleError]
  );

  const otpService = useCallback(
    async (data: string) => {
      await validate({ variables: { input: GetOtpPayload(data, props.token) } })
        .then((x) => props.otpCallback((x?.data as ResponseOtp).otpResponse?.token))
        .catch((x) => {
          setOTP('');
          handleError(x);
        });
    },
    [validate, props, handleError]
  );

  useEffect(() => {
    if (otp.length === APP_OTP_SIZE) {
      const timer = setTimeout(() => otpService(otp), 500);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [otp, props, handleError, otpService, validate]);

  if (loading) return <Spinner />;

  return (
    <TemplateCanje title={CANJE_OTP_TITLE} textAlign={'center'} message={msg}>
      <Box justifyContent="center" marginTop={'25px'} marginBottom={'40px'} flexDirection="column" alignItems={'center'}>
        <Box marginBottom={'40px'} justifyContent="center">
          <BsEnvelopeOpen color={'white'} size={60} />
        </Box>
        <StyledOTP
          isInputNum={true}
          value={otp}
          onChange={(data: string) => setOTP(data)}
          numInputs={APP_OTP_SIZE}
          separator={<StyledSpan fontWeight={600} marginX={'5px'}></StyledSpan>}
        />{' '}
      </Box>
    </TemplateCanje>
  );
};

const StyledOTP = styled(OtpInput)({
  '& input': {
    padding: '0px',
    width: '35px !important',
    height: '35px',
    fontSize: '25px',
    borderRadius: '4px',
    border: `2px solid white`,
    color: `${theme.colors.primary[0]}`,
    userSelect: 'none',

    '@media only screen and (min-width: 576px)': {
      width: '40px !important',
      height: '40px',
    },
  },
});
